export default __webpack_public_path__ + "Content/Images/content/home-content-2.jpg";